var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourseQuiz = function SvgCourseQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0H3a3.01 3.01 0 0 0-3 3v13.99a3.01 3.01 0 0 0 3 3h10a3.01 3.01 0 0 0 3-3V3a3.01 3.01 0 0 0-3-3m1 16.99a1.016 1.016 0 0 1-1 1H3a1.016 1.016 0 0 1-1-1V3a1.016 1.016 0 0 1 1-1h10c.549.009.991.451 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7v14a3.01 3.01 0 0 1-3 3H5a1 1 0 0 1 0-2h12a1.016 1.016 0 0 0 1-1V7a1 1 0 0 1 2 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a3.99 3.99 0 0 1-3 3.87V12a1 1 0 0 1-2 0v-1a1 1 0 0 1 1-1 2 2 0 1 0-2-2 1 1 0 1 1-2 0 4 4 0 1 1 8 0"
  }))));
};
export default SvgCourseQuiz;